export default class Faq {
    constructor() {
       this.init()
    }
 
    init() {
        const list = document.querySelectorAll('[data-faq-item]')

        if (list.length) {
            const input = document.querySelector('[data-faq-input]')
            const button = document.querySelector('[data-faq-button]')

            button.addEventListener('click', () => {
                const search = input.value.toLowerCase()

                list.forEach(i => {
                    const item = i.innerHTML.toLowerCase()
                    if (item.indexOf(search) == -1) { 
                        i.classList.add('d-hide')
                    }  else { 
                        i.classList.remove('d-hide')
                    }
                })

                input.blur()
            })

            input.addEventListener('keypress', e => {
                console.log(e.keyCode)
                if (e.key === 'Enter') {
                    e.preventDefault()
                    button.click()
                }
            })

            input.onkeyup = () => {
                if (!input.value) {
                    list.forEach(i => {
                        i.classList.remove('d-hide')
                    })
                }
            }
        }
    }
}
 


//////////////////
// WEBPACK FOOTER
// ./js/components/faq.js
// module id = 10
// module chunks = 0